<header class="ib-modals__header">
    <h2 class="ib-heading ib-heading--type-1">{{'GIFT_CARD_GROUP_MODAL_TITTLE' | translate}}</h2>
    <div class="ib-modals__header-settings">
        <button type="button" class="ib-modals__button-action icon-cerrar" (click)="close()">
            <span class="u-hide-accessible">{{'HEADER_CONFIRMATION_BACK_MODAL_CLOSE_ACCESS' | translate}}</span>
        </button>
    </div>
</header>
<section class="ib-modals__body">
    <div class="ib-layout__line-spacing">
        
        <div class="ib-table-modal ib-table-modal--responsive ib-table-modal--two-colors">
            <table class="ib-table-modal__tablenoblock">
                <caption class="hide-accessible">{{'GIFT_CARD_CONDITION_MODAL_HEADER_TITLE' | translate}}</caption>
                <thead class="ib-table-modal__head">
                    <tr class="ib-table-modal__row ib-table-modal__row--gray">
                        <th class="ib-table-modal__column hidden-sm hidden-xs"></th>
                        <th class="ib-table-modal__column"> {{'GIFT_CARD_GROUP_GIFT_CARD' | translate}}</th>
                    </tr>
                </thead>
                <tbody class="ib-table-modal__body">
                    <tr class="ib-table-modal__row ib-table-modal__row--gray">
                        <td id="giftCardName" class="ib-table-modal__column hidden-md hidden-lg hidden-xl ">
                            <span class="ib-table-modal__column-txt  ib-table-modal__column-txt--block  ib-table-modal__column-txt--title ">{{'GIFT_CARD_NAME_MODAL' | translate}}</span>
                            <span class="ib-table-modal__column-txt  ib-table-modal__column-txt--block  ib-table-modal__column-txt--text ">{{model.data.cardName}}</span>
                        </td>
                        <td class="ib-table-modal__column ib-table-modal__column--head hidden-sm hidden-xs">{{'GIFT_CARD_NAME_MODAL' | translate}}</td>
                        <td class="ib-table-modal__column hidden-sm hidden-xs">{{model.data.cardName}}</td>
                    </tr>
                    <tr id="operatorsRestrictionRow" class="ib-table-modal__row ib-table-modal__row--gray">
                        <td class="ib-table-modal__column hidden-md hidden-lg hidden-xl">
                            <span class="ib-table-modal__column-txt  ib-table-modal__column-txt--block  ib-table-modal__column-txt--title">{{'GIFT_CARDS_AMOUNT_TO_CONTRIBUTE' | translate}}</span>
                            <span class="ib-table-modal__column-txt  ib-table-modal__column-txt--block  ib-table-modal__column-txt--text">{{model.data.amountToContribute}}</span>
                        </td>
                        <td class="ib-table-modal__column ib-table-modal__column--head hidden-sm hidden-xs">{{'GIFT_CARDS_AMOUNT_TO_CONTRIBUTE' |translate}}</td>
                        <td class="ib-table-modal__column hidden-sm hidden-xs">{{model.data.amountToContribute}}</td>
                    </tr>
                    <tr id="deadlineToContribute" class="ib-table-modal__row ib-table-modal__row--gray">
                        <td class="ib-table-modal__column hidden-md hidden-lg hidden-xl">
                            <span class="ib-table-modal__column-txt  ib-table-modal__column-txt--block  ib-table-modal__column-txt--title">{{'GIFT_CARD_DEADLINE_TO_CONTRIBUTE' | translate}}</span>
                            <span class="ib-table-modal__column-txt  ib-table-modal__column-txt--block  ib-table-modal__column-txt--text">{{model.data.deadLineToContribute}}</span>
                        </td>
                        <td class="ib-table-modal__column ib-table-modal__column--head hidden-sm hidden-xs">{{'GIFT_CARD_DEADLINE_TO_CONTRIBUTE' | translate}}</td>
                        <td class="ib-table-modal__column hidden-sm hidden-xs">{{model.data.deadLineToContribute}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="ib-layout__line-spacing ib-layout__line-spacing--small ib-layout__line-spacing--type-6" style="display: flex; justify-content: flex-end; margin-bottom: 20px;">
        <span class="ib-text--final-amount" >{{'GIFT_CARDS_FINAL_AMOUNT' | translate}} {{model.data.totalAmount}}</span>
    </div>
</section>
<footer class="ib-modals__footer u-text-right">
    <button class="ib-button ib-button--w-medium" type="button" (click)="accept()">{{'GIFT_CARDS_MODAL_BUTTON_ACCEPT' | translate}}</button>
</footer>


